// extracted by mini-css-extract-plugin
module.exports = {"block_item":"linkContact_block_item__36CMh","images":"linkContact_images__11m2n"};